import { createElement, init } from '@airwallex/components-sdk';
import { useEffect, useState } from "react";
import Common from "../Common/Common";
import NetProtocol from '../Net/NetProtocol';
import { HttpNetPost } from '../Net/HttpNetMg';
import { useParams } from 'react-router-dom';
import cssstyle from './index.module.scss';

const AirwallexPay = ()=>{
    const {pid} = useParams();
    const [ErrorTips, SetErrorTips] = useState("");
    const [IsPay, SetIsPay] = useState(false);
    const onPayBack = ()=>{
        window.close();
    }

    useEffect(() => {
        if(!pid){
            SetErrorTips("the pid is null");
            return;
        }
        const loadDropInElement = async () => {
            Common.Common.ShowLoading = true;
            await init({
                env: 'demo', // Can choose other production environments, 'staging | 'demo' | 'prod'
                enabledElements: ['payments'],
            });
            const resData:NetProtocol = await HttpNetPost("/getairwallexpay", {pid:pid}, false);
            if(resData.code === 0){
                const { id, client_secret, currency } = resData.data.order;
                const element = await createElement('dropIn', {
                    intent_id: id,
                    client_secret: client_secret,
                    currency: currency
                });
                element?.mount('drop-in');
                Common.Common.ShowLoading = false;
            }
            else{
                Common.Common.ShowLoading = false;
                console.log(resData.msg);
                SetErrorTips(resData.msg);
            }
        };
        loadDropInElement();
        // STEP #6: Add an event listener to handle events when the element is mounted
        const onReady = (event: CustomEvent): void => {
            console.log(`Element is mounted: ${JSON.stringify(event.detail)}`);
        };
        // STEP #7: Add an event listener to handle events when the payment is successful.
        const onSuccess = (event: CustomEvent): void => {
            console.log(`Confirm success with ${JSON.stringify(event.detail)}`);
            SetIsPay(true);
        };
        // STEP #8: Add an event listener to handle events when the payment has failed.
        const onError = (event: CustomEvent) => {
            const { error } = event.detail;
            console.error('There is an error', error);
        };
        const domElement = document.getElementById('dropIn');
        domElement?.addEventListener('onReady', onReady as EventListener);
        domElement?.addEventListener('onSuccess', onSuccess as EventListener);
        domElement?.addEventListener('onError', onError as EventListener);
        return () => {
            domElement?.removeEventListener('onReady', onReady as EventListener);
            domElement?.removeEventListener('onSuccess', onSuccess as EventListener);
            domElement?.removeEventListener('onError', onError as EventListener);
        };
    }, []);
    
    const containerStyle = {
        width: '540px',
        margin: '48px auto',
    };
    return(
        <div className={cssstyle.bg}>
        {
            IsPay?<div className={cssstyle.divitem}>
                <div>
                Thank you for supporting our product
                </div>
                <button id="closeButton" onClick={onPayBack}>
                    OK
                </button>
            </div>:
            ErrorTips == ""?
            <div
                id="dropIn"
                style={{
                    ...containerStyle, // Example: container styling can be moved to css
                }}
            />
            :
            <div className={cssstyle.divitem} onClick={onPayBack}>
                {ErrorTips}
            </div>
        }
        </div>
    )
}

export default AirwallexPay;